import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Table, Space, Button, Typography, Tag } from "antd";
import c from "../../utils/common";
import metaData from "../../data/metaData";
import log from "../../utils/log";
import moment from "moment";

//
import Meta from "../Meta";
import ActionHeader from "../Table/ActionHeader";
import CheckBox from "../General/Checkbox";
import ProductPeriod from "../Table/ProductPeriod";
import ProductTag from "../Table/ProductTag";

const { Text, Title } = Typography;

const VoucherTable = ({
  data,
  loading,
  canAdd = false,
  canDelete = false,
  canSelect = false,
  onSelect,
  onAdd,
  onDelete,
}) => {
  const history = useHistory();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pagination, setPagination] = useState(1);
  const [filteredDataCount, setFilteredDataCount] = useState(data.length);

  const columns = [
    {
      title: "Voucher",
      dataIndex: "name",
      key: "name",
      width: 350,
      render: (text, record) => {
        return (
          <Meta
            image={
              record?.gallery?.[0] ? (
                <img
                  style={{ width: 75, objectFit: "cover", marginRight: "0.5rem" }}
                  src={metaData.blobPreURL + "clientUpload-" + record.gallery[0] + ".jpeg" + metaData.blobPostURL}
                />
              ) : null
            }
            title={<Title level={5}>{record?.name}</Title>}
            description={<ProductTag product={record} />}
            maxWidth={200}
          />
        );
      },
      sorter: (a, b) => (a?.name).localeCompare(b?.name),
    },
    {
      title: "Qty Per Collection",
      dataIndex: "qtyPerCollection",
      key: "qtyPerCollection",
      width: 150,
      render: (text, record) => {
        return <Text strong>{record?.qtyPerCollection || 0}</Text>;
      },
    },
    {
      title: "Available Qty",
      dataIndex: "qty.available",
      key: "qty.available",
      width: 150,
      render: (text, record) => {
        return (
          <Row style={{ width: "100%" }}>
            <Row style={{ width: "100%" }}>
              <Text strong>{record?.qty?.available || 0}</Text>
            </Row>

            {record?.qty?.available < record?.qtyPerCollection && (
              <>
                <Text strong>Insufficient Qty</Text>
                <a
                  onClick={() => {
                    history.push("/merchantUser/product/" + record?.id);
                  }}
                >
                  Issue More
                </a>
              </>
            )}
          </Row>
        );
      },
    },

    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        return (
          <Space size="middle">
            {canDelete ? (
              <Button danger loading={loading} onClick={() => onDelete(record?.id)}>
                Remove
              </Button>
            ) : null}
            {canAdd ? (
              <Button type="primary" loading={loading} onClick={() => onAdd(record?.id)}>
                Add
              </Button>
            ) : null}
            {canSelect ? (
              <CheckBox
                checked={record?.selected}
                size="1.75rem"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent the row click event from being triggered
                  onSelect(record?.id);
                }}
              />
            ) : null}
          </Space>
        );
      },
    },
  ];

  const handleActionClick = (key) => {
    log.debug(key);
  };

  // Handle pagination change (page number or page size change)
  const handleTableChange = (pagination, filters, sorter, extra) => {
    const { current, pageSize } = pagination;
    setPagination(current);
    setFilteredDataCount(extra.currentDataSource.length);
  };

  return (
    <>
      <ActionHeader
        pagination={pagination}
        pageSize={20}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        count={filteredDataCount}
        onActionClick={handleActionClick}
      />

      <Table
        className="white-table-header"
        columns={columns}
        dataSource={data}
        pagination={{
          current: pagination,
          pageSize: 20,
          position: ["none", "bottomCenter"],
          showSizeChanger: false,
        }}
        onRow={
          canSelect
            ? (record) => ({
                onClick: () => {
                  onSelect(record.id);
                },
              })
            : undefined
        }
        onChange={handleTableChange} // Handles next/prev page
      />
    </>
  );
};

export default VoucherTable;
